export type KV = {
  getItem(k: string): string | null
  setItem(k: string, v: string): void
}

let memoryDeviceId: string | null = null

// Estável por navegador/perfil: localStorage primeiro; nunca window.name.
export function resolveDeviceId(
  storage: KV | null,
  genId: () => string,
): string {
  try {
    const stored = storage?.getItem('deviceId')
    if (stored) return stored // inclui ids antigos `dev_<hash>` (já estáveis)
    const id = 'dev_' + genId()
    storage?.setItem('deviceId', id)
    return id
  } catch {
    return (memoryDeviceId ??= 'dev_' + genId()) // storage bloqueado: estável só na sessão
  }
}

// GUID da sessão (window.name) — o que antes era gravado como deviceId.
export function resolveSessionId(
  winName: string | undefined,
): string | undefined {
  return winName && winName.length > 0 ? winName : undefined
}

// Ids antigos (GUID sem prefixo `dev_`) são sessões, não aparelhos.
export const isStableDeviceId = (id?: string | null) =>
  !!id && id.startsWith('dev_')
